module.exports = __webpack_public_path__ + "img/19ne.ec3dec8e.svg";